var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DataView-atten"},[_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }